import * as Yup from 'yup';

export default Yup.object().shape({
  hasAntiFraud: Yup.boolean(),
  expirationDate: Yup.string().when('licenseType', {
    is: (licenseType) => licenseType !== 'SUBSCRIPTION',
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional(),
  }),
  readingAmount: Yup.number(),
  listeningAmount: Yup.number(),
  writingAmount: Yup.number(),
  speakingAmount: Yup.number(),
  fullTestAmount: Yup.number(),
  readingPracticeAmount: Yup.number(),
  listeningPracticeAmount: Yup.number(),
  writingPracticeAmount: Yup.number(),
  speakingPracticeAmount: Yup.number(),
  cefrAmount: Yup.number(),
  mcerAmount: Yup.number(),
  name: Yup.string(),
  licenseType: Yup.string(),
  readingWritingAmount: Yup.number(),
  readingWritingPracticeAmount: Yup.number(),
  studentId: Yup.string(),
  customCategoriesAmount: Yup.array(),
  photoStudent: Yup.boolean(),
  photoUploadId: Yup.boolean(),
  photoUploadType: Yup.string(),
  takePictureNextId: Yup.boolean(),
  screenShare: Yup.boolean(),
  roomScan360: Yup.boolean(),
  roomScanRandom: Yup.boolean(),
  enableUserScreenRecording: Yup.boolean(),
  enableUserVideoRecording: Yup.boolean(),
  enableUserAudioRecording: Yup.boolean(),
  durationInMonths: Yup.number(),
});
